import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP Error:', error);

      // Handle specific error statuses
      if (error.status === 401) {
        console.error('Unauthorized access - redirecting to login.');
        // Add logic to redirect to login or show a message
      } else if (error.status === 500) {
        console.error('Server error - please try again later.');
      }

      // Optionally, show a user-friendly error message
      //alert('An error occurred: ' + (error.error?.message || 'Unknown error'));

      return throwError(() => error);
    })
  );
};